/* eslint-disable no-nested-ternary */
import { Icon, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import { useCreditRate } from './hooks/use-credit-rate';
import * as SX from './sx';
import type { PlanCreditRateProps as Props } from './types';

export const PlanCreditRate = memo(({ className }: Props) => {
  const { isPaid, isCompact, isMostPopular } = usePlanCardContext();
  const creditRate = useCreditRate();

  const textColor =
    isCompact && isMostPopular
      ? 'common.white'
      : isCompact
      ? 'grey.700'
      : isMostPopular
      ? 'common.white'
      : 'grey.700';

  return (
    <Stack
      className={classnames('PlanCreditRate', className)}
      sx={SX.root}
      alignItems="flex-start"
    >
      <Box sx={SX.labelRow}>
        <Typography variant="body4" fontWeight={700} color={textColor} noWrap>
          {isPaid ? 'Plan Rate' : 'Always Free'}
        </Typography>
        <Tooltip
          title={
            isPaid
              ? 'Your effective cost per 1K credits based on your selected plan.'
              : 'Credits refresh monthly. Unused credits don’t roll over.'
          }
          placement="right"
          arrow
        >
          <Box sx={SX.tooltipAnchor}>
            <Icon name="info" size={18} color="grey.400" />
          </Box>
        </Tooltip>
      </Box>
      <Box sx={SX.labelSlot}>
        {isPaid && creditRate && (
          <Label
            color="primary"
            variant="soft"
            size="xxxsmall"
            endIcon={<Icon name="coin" size={16} />}
          >
            ${creditRate} / 1K credits
          </Label>
        )}
      </Box>
    </Stack>
  );
});

PlanCreditRate.displayName = 'PlanCreditRate';
